import type { Consultant } from '@/shared/types/consultants';

const ISO = '2025-01-15T10:00:00.000Z';

export const mockConsultants: Consultant[] = [
  {
    id: 'consultant_1',
    firstName: 'Jean',
    lastName: 'Dupont',
    email: 'jean.dupont@example.com',
    phone: '+33 6 12 34 56 78',
    position: 'Développeur React',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_2',
    firstName: 'Marie',
    lastName: 'Martin',
    email: 'marie.martin@example.com',
    phone: '+33 6 23 45 67 89',
    position: 'Product Manager',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_3',
    firstName: 'Pierre',
    lastName: 'Durand',
    email: 'pierre.durand@example.com',
    phone: '+33 6 34 56 78 90',
    position: 'Développeur Fullstack',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_4',
    firstName: 'Sofia',
    lastName: 'Leroy',
    email: 'sofia.leroy@example.com',
    phone: '+33 6 11 22 33 44',
    position: 'UX Designer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_5',
    firstName: 'Lucas',
    lastName: 'Bernard',
    email: 'lucas.bernard@example.com',
    phone: '+33 6 22 33 44 55',
    position: 'Data Engineer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_6',
    firstName: 'Emma',
    lastName: 'Moreau',
    email: 'emma.moreau@example.com',
    phone: '+33 6 33 44 55 66',
    position: 'QA Engineer',
    status: 'INACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_7',
    firstName: 'Hugo',
    lastName: 'Petit',
    email: 'hugo.petit@example.com',
    phone: '+33 6 44 55 66 77',
    position: 'DevOps Engineer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_8',
    firstName: 'Chloé',
    lastName: 'Faure',
    email: 'chloe.faure@example.com',
    phone: '+33 6 55 66 77 88',
    position: 'Product Designer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_9',
    firstName: 'Thomas',
    lastName: 'Garcia',
    email: 'thomas.garcia@example.com',
    phone: '+33 6 66 77 88 99',
    position: 'Scrum Master',
    status: 'INACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_10',
    firstName: 'Léa',
    lastName: 'Robert',
    email: 'lea.robert@example.com',
    phone: '+33 6 77 88 99 00',
    position: 'Business Analyst',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_11',
    firstName: 'Noah',
    lastName: 'Richard',
    email: 'noah.richard@example.com',
    phone: '+33 6 10 20 30 40',
    position: 'Backend Java',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_12',
    firstName: 'Manon',
    lastName: 'Simon',
    email: 'manon.simon@example.com',
    phone: '+33 6 20 30 40 50',
    position: 'Frontend Vue.js',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_13',
    firstName: 'Adam',
    lastName: 'Michel',
    email: 'adam.michel@example.com',
    phone: '+33 6 30 40 50 60',
    position: 'Cloud Architect',
    status: 'INACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_14',
    firstName: 'Jade',
    lastName: 'Lemaire',
    email: 'jade.lemaire@example.com',
    phone: '+33 6 40 50 60 70',
    position: 'Data Analyst',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_15',
    firstName: 'Enzo',
    lastName: 'Rousseau',
    email: 'enzo.rousseau@example.com',
    phone: '+33 6 50 60 70 80',
    position: 'Fullstack TypeScript',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_16',
    firstName: 'Camille',
    lastName: 'Blanc',
    email: 'camille.blanc@example.com',
    phone: '+33 6 60 70 80 90',
    position: 'UX Researcher',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_17',
    firstName: 'Louis',
    lastName: 'Gauthier',
    email: 'louis.gauthier@example.com',
    phone: '+33 6 70 80 90 10',
    position: 'Tech Lead',
    status: 'INACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_18',
    firstName: 'Sarah',
    lastName: 'Chevalier',
    email: 'sarah.chevalier@example.com',
    phone: '+33 6 80 90 10 20',
    position: 'Product Owner',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_19',
    firstName: 'Nathan',
    lastName: 'Lopez',
    email: 'nathan.lopez@example.com',
    phone: '+33 6 90 10 20 30',
    position: 'Mobile Developer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_20',
    firstName: 'Zoé',
    lastName: 'Fernandez',
    email: 'zoe.fernandez@example.com',
    phone: '+33 6 91 21 31 41',
    position: 'UI Designer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_21',
    firstName: 'Léo',
    lastName: 'Henry',
    email: 'leo.henry@example.com',
    phone: '+33 6 92 22 32 42',
    position: 'Security Engineer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_22',
    firstName: 'Anna',
    lastName: 'Schmidt',
    email: 'anna.schmidt@example.com',
    phone: '+33 6 93 23 33 43',
    position: 'Data Scientist',
    status: 'INACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_23',
    firstName: 'Gabriel',
    lastName: 'Philippe',
    email: 'gabriel.philippe@example.com',
    phone: '+33 6 94 24 34 44',
    position: 'Backend .NET',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_24',
    firstName: 'Inès',
    lastName: 'Renaud',
    email: 'ines.renaud@example.com',
    phone: '+33 6 95 25 35 45',
    position: 'Frontend Angular',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_25',
    firstName: 'Mathis',
    lastName: 'Dupuis',
    email: 'mathis.dupuis@example.com',
    phone: '+33 6 96 26 36 46',
    position: 'SRE',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_26',
    firstName: 'Léna',
    lastName: 'Collet',
    email: 'lena.collet@example.com',
    phone: '+33 6 97 27 37 47',
    position: 'Project Manager',
    status: 'INACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_27',
    firstName: 'Yanis',
    lastName: 'Meyer',
    email: 'yanis.meyer@example.com',
    phone: '+33 6 98 28 38 48',
    position: 'Dev Fullstack Node.js',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_28',
    firstName: 'Mila',
    lastName: 'Perrot',
    email: 'mila.perrot@example.com',
    phone: '+33 6 99 29 39 49',
    position: 'Marketing Tech',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_29',
    firstName: 'Timéo',
    lastName: 'Barbier',
    email: 'timeo.barbier@example.com',
    phone: '+33 6 10 30 50 70',
    position: 'Data Ops',
    status: 'INACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
  {
    id: 'consultant_30',
    firstName: 'Louna',
    lastName: 'Rossi',
    email: 'louna.rossi@example.com',
    phone: '+33 6 11 31 51 71',
    position: 'Growth Engineer',
    status: 'ACTIVE',
    createdAt: ISO,
    updatedAt: ISO,
  },
];
